"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CrownNav: ()=>CrownNav
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_CrownNav_variants_cjs_namespaceObject = require("./CrownNav.variants.cjs");
const CLEAN_PROPS = [
    'title',
    'subtitle',
    'breadcrumb',
    'actions'
];
function CrownNav({ title, subtitle, breadcrumb, actions, children, className, ...props }) {
    const styles = (0, external_CrownNav_variants_cjs_namespaceObject.crownNavVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        ...(0, index_cjs_namespaceObject.cleanProps)(props, CLEAN_PROPS),
        className: (0, index_cjs_namespaceObject.cn)(styles.root(), className),
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: styles.container(),
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: styles.titleGroup(),
                    children: [
                        'string' == typeof title ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                            textStyle: "heading2",
                            children: title
                        }) : title,
                        subtitle && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                            textStyle: "body1",
                            palette: "neutral",
                            shade: "11",
                            children: subtitle
                        }),
                        breadcrumb && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: styles.breadcrumb(),
                            children: breadcrumb
                        })
                    ]
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: styles.actionsGroup(),
                    children: [
                        children,
                        actions && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: styles.actions(),
                            children: actions
                        })
                    ]
                })
            ]
        })
    });
}
exports.CrownNav = __webpack_exports__.CrownNav;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CrownNav"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
